import { createErrorWrapper } from '../utils';

export const SAVE_ERROR = 'PHONE.SAVE_ERROR';
export const CHECK_ERROR = 'PHONE.CHECK_ERROR';

export const saveErr = createErrorWrapper(SAVE_ERROR, 'Failed to save phone');
export const checkErr = createErrorWrapper(CHECK_ERROR, 'Failed to check code');
